module.exports = __webpack_public_path__ + "img/customerservice.78c88533.png";